var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('a',{attrs:{"href":"mailto:info@grotec.co.uk"}},[_vm._v("info@grotec.co.uk")])])])
}]

export { render, staticRenderFns }